import React, { useEffect, useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import styles from './styles';
import PropertiesIcon from '../../../../common/icons/PropertiesIcon';
import AccountIcon from '../../../../common/icons/AccountIcon';
import { ScreenURLMap } from '../../constants'
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import { events, categories } from '../../constants/analytics-constant';
import Analytics from '../../../../common/utils/analyticsUtil';
import { useTheme, Typography } from '@hmsexp/component-library';
import getRoutePath from '../../utils/getRoutePath';

const Footer = (props) => {
  const { history, customHistory } = props;
  const currentRoute = get(history, 'location.pathname');
  const intl = useIntl();
  const [activeRoute, setActiveRoute] = useState('');
  const theme = useTheme();

  useEffect(() => {
    let screenName = '';
    switch (currentRoute) {
      case ScreenURLMap.property_dashboard.url:
        screenName = 'MyProperties';
        break;
      case ScreenURLMap.property_account.url:
        screenName = 'Account';
        break;
      default:
        screenName = '';
        break;
    }
    setActiveRoute(screenName)
  }, [currentRoute]);

  const onPropertiesClick = () => {
    customHistory.push({
      webURL: getRoutePath({ path: ScreenURLMap.property_dashboard.countrySpecificUrl }),
      appScreenName: ScreenURLMap.property_dashboard.screenName,
    });
    Analytics.logAnalyticsEvent({
      category: categories.SELF_ONBOARDING,
      eventName: events.SELF_ONBOARDING_FOOTER,
      eventAction: 'my_properties_clicked'
    });
  }

  const onAccountClick = () => {
    customHistory.push({
      webURL: getRoutePath({ path: ScreenURLMap.property_account.countrySpecificUrl }),
      appScreenName: ScreenURLMap.property_account.screenName,
    });
    Analytics.logAnalyticsEvent({
      category: categories.SELF_ONBOARDING,
      eventName: events.SELF_ONBOARDING_FOOTER,
      eventAction: 'account_clicked'
    });
  }

  return <View style={[styles.footerContainer,{borderColor:theme.palette.borderColor,backgroundColor:theme.palette.background}]}>
    <TouchableOpacity
      onPress={onPropertiesClick}
      style={[
        styles.optionContainer,activeRoute === 'MyProperties'&&{borderTopColor:theme.palette.primaryContentHigh,borderTopWidth:1}
      ]}>
      <PropertiesIcon stroke={activeRoute === 'MyProperties' ? theme.palette.primaryContentHigh : theme.palette.primaryContentMedium} />
      <Typography variant='overline' fontWeightType='medium' color={activeRoute === 'MyProperties' ? 'primaryContentHigh' : 'primaryContentMedium'}>
        {intl.formatMessage({ id: 'footerMyPropertiesTitle' })}
      </Typography>
    </TouchableOpacity>
    <TouchableOpacity
      onPress={onAccountClick}
      style={[
        styles.optionContainer,activeRoute === 'Account'&&{borderTopColor:theme.palette.primaryContentHigh,borderTopWidth:1}
      ]}>
      <AccountIcon stroke={activeRoute === 'Account' ? theme.palette.primaryContentHigh : theme.palette.primaryContentMedium} />
      <Typography variant='overline' fontWeightType='medium' color={activeRoute === 'Account' ? 'primaryContentHigh' : 'primaryContentMedium'}>
        {intl.formatMessage({ id: 'footerAccountTitle' })}
      </Typography>
    </TouchableOpacity>
  </View>
}

export default Footer;
